
import React, { useState } from 'react'

import Error from '../../Error/Error'
import Fieldset from '../../Modifiers/Fieldset/Fieldset'
import Progress from '../../Progress/Progress'
import { SavedAddress } from './SavedAddress/SavedAddress'
import { useSavedAddresses } from '../../use-saved-addresses/use-saved-addresses'

export const SavedAddressForm = () => {
  const [editGuid, setEditing] = useState(null)
  const { savedAddresses, loading, error, refetch } = useSavedAddresses()
  if (loading) return <Progress eventData={{ category: 'SavedAddressForm' }} />
  if (error) return <Error error={error} retry={refetch} />

  return (
    <Fieldset label={'Delivery Information'} collapsable>
      {savedAddresses.length === 0
        ? <p>No Addresses</p>
        : savedAddresses.map(savedAddress => (
          <SavedAddress
            key={savedAddress.guid}
            savedAddress={savedAddress}
            setEditing={setEditing}
            editing={editGuid === savedAddress.guid}
          />
        ))}
    </Fieldset>
  )
}
